interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="loading-overlay">
      <div className="spinner" />
      {message && <div className="loading-overlay__text">{message}</div>}
    </div>
  );
}
